import lmsRoutes from "@/router/items/LmsRoutes";

const adminRoutes = [...lmsRoutes];

export default adminRoutes;
